import { ValueOpt } from "best-common-react";
import { EmailListData } from "../types/emailList.ts";

export const EmailListColumnHeaders: ValueOpt<keyof EmailListData>[] = [
  {
    label: "Account Number",
    value: "accountnum"
  },
  {
    label: "Address 1",
    value: "address1"
  },
  {
    label: "Address 2",
    value: "address2"
  },
  {
    label: "Attribute 1",
    value: "attribute1"
  },
  {
    label: "Attribute 2",
    value: "attribute2"
  },
  {
    label: "Attribute 3",
    value: "attribute3"
  },
  {
    label: "Attribute 4",
    value: "attribute4"
  },
  {
    label: "Attribute 5",
    value: "attribute5"
  },
  {
    label: "Attribute 6",
    value: "attribute6"
  },
  {
    label: "Attribute 7",
    value: "attribute7"
  },
  {
    label: "Attribute 8",
    value: "attribute8"
  },
  {
    label: "Attribute 9",
    value: "attribute9"
  },
  {
    label: "Attribute 10",
    value: "attribute10"
  },
  {
    label: "Attribute 11",
    value: "attribute11"
  },
  {
    label: "Attribute 12",
    value: "attribute12"
  },
  {
    label: "Attribute 13",
    value: "attribute13"
  },
  {
    label: "Attribute 14",
    value: "attribute14"
  },
  {
    label: "Attribute 15",
    value: "attribute15"
  },
  {
    label: "Attribute 16",
    value: "attribute16"
  },
  {
    label: "Attribute 17",
    value: "attribute17"
  },
  {
    label: "Attribute 18",
    value: "attribute18"
  },
  {
    label: "Attribute 19",
    value: "attribute19"
  },
  {
    label: "Attribute 20",
    value: "attribute20"
  },
  {
    label: "Birth Date",
    value: "birthdate"
  },
  {
    label: "City",
    value: "city"
  },
  {
    label: "Comments",
    value: "comments"
  },
  {
    label: "Company",
    value: "company"
  },
  {
    label: "E-mail Address",
    value: "email"
  },
  {
    label: "First Name",
    value: "fname"
  },
  {
    label: "Gender",
    value: "gender"
  },
  {
    label: "Home Telephone",
    value: "hometel"
  },
  {
    label: "Last Name",
    value: "lname"
  },
  {
    label: "Login",
    value: "login"
  },
  {
    label: "Password",
    value: "passwd"
  },
  {
    label: "Promotion Code",
    value: "promotioncode"
  },
  {
    label: "Salutation",
    value: "salutation"
  },
  {
    label: "Season Ticket Holder Type",
    value: "sth_type"
  },
  {
    label: "State",
    value: "state"
  },
  {
    label: "URL",
    value: "url"
  },
  {
    label: "Work Telephone",
    value: "worktel"
  },
  {
    label: "Zip Code",
    value: "zip"
  }
];

export const ListUploadTypeOptions: ValueOpt<string>[] = [
  {
    label: "Commercial",
    value: "Commercial"
  },
  {
    label: "Service",
    value: "Service"
  }
];
